import React from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Weir Roastin'
            </Typography>
            <Typography variant="body2">
              Authentic whole hog BBQ since 1961.
              Locally owned and operated.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/" color="inherit">
                Home
              </Link>
              <Link component={RouterLink} to="/about" color="inherit">
                About
              </Link>
              <Link component={RouterLink} to="/services" color="inherit">
                Services
              </Link>
              <Link component={RouterLink} to="/contact" color="inherit">
                Contact
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              For bookings and inquiries
            </Typography>
            <Link
              href="tel:+1234567890"
              color="inherit"
              sx={{ display: 'block', mb: 1 }}
            >
              (123) 456-7890
            </Link>
            <Link
              href="mailto:info@weirroastin.com"
              color="inherit"
              sx={{ display: 'block' }}
            >
              info@weirroastin.com
            </Link>
          </Grid>
        </Grid>
        <Typography
          variant="body2"
          sx={{ mt: 4, textAlign: 'center', opacity: 0.8 }}
        >
          © {new Date().getFullYear()} Weir Roastin'. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
